export default "__VITE_ASSET__9gTpsXyq__"